import React from "react";
import { withNavBars } from "../../HOCs";
import { Dashboardbanner } from "./dashboardbanner";

class DashboardbannerParent extends React.Component {
    render() {
        return <Dashboardbanner {...this.props}/>;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(DashboardbannerParent, props);
